export default "__VITE_ASSET__C_tO3S$E__"